import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { useStoreActions } from "../../../contexts";
import CopyAPIKeyModal from "./CopyAPIKeyModal";
import styles from "./RegenerateAPIKeyModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RegenerateAPIKeyModal = _ref => {
  let {
    apiKey,
    dismissModal,
    refresh
  } = _ref;
  const {
    api
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Regenerate API key",
    content: /*#__PURE__*/_jsxs(Typography, {
      className: styles.regenerateApiKeyModalContent,
      "data-testid": "regenerate-api-key-modal-content",
      children: ["Regenerating this API key will immediately block access for any connected platforms or services until they are updated with the newly generated key. ", /*#__PURE__*/_jsx("br", {}), " ", /*#__PURE__*/_jsx("br", {}), " Are you sure you want to proceed?"]
    }),
    primaryButtonLabel: "Regenerate API key",
    onPrimaryButtonClick: async () => {
      try {
        const {
          apiKey: apiKeyValue
        } = await api.business.regenerateAPIKey(apiKey.id);
        await refresh();
        overlayContext.showModal({
          content: _ref2 => {
            let {
              dismissModal
            } = _ref2;
            return /*#__PURE__*/_jsx(CopyAPIKeyModal, {
              apiKeyName: apiKey.name,
              apiKeyValue: apiKeyValue,
              dismissModal: dismissModal
            });
          }
        });
      } catch (error) {
        overlayContext.showErrorToast('Failed to regenerate API key', 'regenerate-api-key-error');
      } finally {
        dismissModal();
      }
    },
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: dismissModal,
    "data-testid": "regenerate-api-key-modal"
  });
};